<ng-container *ngIf="content$ | async as content">
  <ng-container *ngIf="branding$ | async as branding">
    <div class="about-hero-banner">
      <img class="about-tenant-hero" [src]="branding.heroImageUrl" alt="" aria-hidden="true">
      <div class="about-hero-overlay">
        <h1 class="about-hero-title">About Us</h1>
      </div>
    </div>

    <div class="about-container">
      <section class="about-introduction" aria-label="About introduction">
        <p>{{ content.about.introduction }}</p>
      </section>

      <div class="about-sections">
        @for (section of content.about.sections; track $index) {
          <section class="about-section" [class.about-image-right]="$index % 2 === 0">
            <div class="about-section-image">
              <img
                [src]="section.imageUrl || branding.heroImageUrl"
                [alt]="content.leagueName + ' — ' + section.heading"
              >
            </div>
            <div class="about-section-copy">
              <h2>{{ section.heading }}</h2>
              @for (paragraph of section.paragraphs; track $index) {
                <p>{{ paragraph }}</p>
              }
            </div>
          </section>
        }
      </div>
    </div>

    <app-footer></app-footer>
  </ng-container>
</ng-container>
